module.exports = __webpack_public_path__ + "static/media/logo-steam.81116cd2.svg";